import RequestBase from './RequestBase';

export class IssueCardRequest extends RequestBase {
    constructor(accountId, paymentCardTypeId) {
        super();
        this._url = '/Cards';
        this.method = 'POST';
        this.contentType = 'application/json';
        this.parameters = [
            'accountId',
            'paymentCardTypeId'
        ];
        this.body = {
            'accountId': accountId,
            'paymentCardTypeId': paymentCardTypeId
        };
    }
}

export class ActivateCardRequest extends RequestBase {
    constructor(customerId, lastFourDigit) {
        super();
        this._url = '/Cards/Pans';
        this.method = 'PATCH';
        this.contentType = 'application/json';
        this.parameters = [
            'customerId',
            'lastFourDigit'
        ];
        this.body = {
            'customerId': customerId,
            'lastFourDigit': lastFourDigit
        };
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Cards.js